// Func = limiting Scope for this file
var lastScrollTop = 0;
var _responsive = true;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	
    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	// BURGER MENU NAVIGATION:

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

			const menuBtn = document.getElementById('menu-btn');
			const navigation = document.querySelector('.navigation');
			const closeMenuBtn = document.querySelector('.js-close-menu');

			menuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.add('open');
			});

			closeMenuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.remove('open');
			});

		// BURGUER MENU MOBILE ----------------------------------------------------------------

			const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
			const burgerMenuContainer = document.querySelector("#js-menuContainer")
			const closeMenu = document.querySelector(".js-burger-close");
			
			//Open Menu

			if(burgerMenuBtn){
				burgerMenuBtn.addEventListener('click', function (e) {
					e.preventDefault();
					burgerMenuContainer.classList.add("open");
					document.body.classList.add("no-scroll");
				});
			}
			
			if(closeMenu){
				closeMenu.addEventListener('click', () => {
					burgerMenuContainer.classList.remove("open");
					document.body.classList.remove("no-scroll");
				});
			}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		};

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


	// EXTRA CLASS TO BUTTONS ****************************************************************

	let addClassToButtons = document.querySelectorAll('.btn');

	if(addClassToButtons){
		addClassToButtons.forEach(btn => {
			btn.classList.add('btn-line', 'btn-tertiary');
		});
	}


	// Main Nav Dropdown on hover ----------------------------------------------------------------
	// const navItems = document.querySelectorAll('#primary-nav li');
	// if(navItems){
	// 	navItems.forEach(function (item) {
	// 		item.addEventListener('mouseover', function () {
	// 			item.classList.add('hover');
	// 			let submenu = item.querySelector('ul.submenu');
	// 			if (submenu) {
	// 				submenu.classList.add('open');
	// 			}
	// 		});
	
	// 		item.addEventListener('mouseout', function () {
	// 			item.classList.remove('hover');
	// 			let submenu = item.querySelector('ul.submenu');
	// 			if (submenu) {
	// 				submenu.classList.remove('open');
	// 			}
	// 		});
	// 	});
	// }


	// FORMS: 

	//// Forms animation for labels   ----------------------------------------------------------------

	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}

	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	// Start Planning Form Functionality 
	
	const documentContainer = document.documentElement;

	let startPlanningBtn = document.querySelectorAll('.js-startPlanning');
	let startPlanningContainer = document.querySelector('.start-planning');
	let closeFormBtn = document.querySelector('.js-close-form');

	if(startPlanningBtn){
		startPlanningBtn.forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				startPlanningContainer.classList.toggle('show');
				scrollToTop()
			});
		})
	}

	
	if(closeFormBtn){
		closeFormBtn.addEventListener('click', (e) => {
			e.preventDefault();
			startPlanningContainer.classList.remove('show');
		});
	}

	function scrollToTop() {
		documentContainer.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	
	

})();



function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');

			let logoUrl = '/assets/svg/logo-scroll.svg';
			// document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			
			let logoUrl = '/assets/svg/logo.svg';
			// document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.navigation');
    const closeButton = document.querySelector('.close-button');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    function updateMenuTabIndex() {
        const isMenuVisible = menu && menu.classList.contains('open');
        elements.forEach(el => el.setAttribute('tabindex', isMenuVisible ? '0' : '-1'));
    }

    if (menu) {
        document.addEventListener('focusin', updateMenuTabIndex);
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }

    if (closeButton) {
        closeButton.addEventListener('keydown', (event) => {
            if (['Enter', ' '].includes(event.key)) {
                event.preventDefault();
                menu.classList.remove('open');
            }
        });
    }
    updateMenuTabIndex();
});
